import { render, staticRenderFns } from "./onlinerate.vue?vue&type=template&id=5fca6be8&scoped=true&"
import script from "./onlinerate.vue?vue&type=script&lang=js&"
export * from "./onlinerate.vue?vue&type=script&lang=js&"
import style0 from "./onlinerate.vue?vue&type=style&index=0&id=5fca6be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca6be8",
  null
  
)

export default component.exports